// PrivacyPolicy.jsx
import '../../input.css'
import { useTranslation } from 'react-i18next'
import Policy from './Policy'

const privacyPolicyPt = (
  <div className="leading-12">
    <p>
      Esta Política de Privacidade descreve como a LEANIT101 SERVIÇOS EM
      INFORMÁTICA, CNPJ 22.724.260/0001-42 ("Lean it 101", "nós") coleta, usa e
      compartilha dados pessoais ao fornecer o Benjamin.
    </p>
    <br />
    <div>
      <strong>Resumo rápido</strong>
      <ul>
        <li>Coletamos dados para operar o Benjamin e processar pagamentos.</li>
        <li>Seus dados não são vendidos.</li>
        <li>Você pode solicitar acesso, correção ou exclusão.</li>
        <li>Podemos usar dados desidentificados para melhorar o produto.</li>
      </ul>
    </div>
    <br />
    <div>
      <strong>1. Papéis sob a LGPD</strong>
    </div>
    <br />
    <div>
      Para dados de conta, faturamento e suporte, atuamos como Controladora.
      Para conteúdos enviados por Clientes (ex.: dados de usuários finais),
      atuamos como Operadora, conforme instruções do Cliente Controlador.
    </div>
    <br />
    <div>
      <strong>2. Quais dados coletamos</strong>
    </div>
    <br />
    <ul>
      <li>
        <strong>Dados de conta:</strong> nome, e-mail, empresa, cargo, telefone.
      </li>
      <li>
        <strong>Dados de pagamento:</strong> transações processadas pela Stripe.
      </li>
      <li>
        <strong>Dados de uso:</strong> logs, IP, navegador, eventos de acesso.
      </li>
      <li>
        <strong>Conteúdo do Cliente:</strong> textos, arquivos e instruções
        enviados ao Benjamin.
      </li>
      <li>
        <strong>Integrações:</strong> dados enviados para conectar CRMs,
        agendas e canais.
      </li>
    </ul>
    <br />
    <div>
      <strong>3. Como usamos os dados</strong>
    </div>
    <br />
    <ul>
      <li>Prestar os Serviços, suporte e comunicação operacional.</li>
      <li>Processar pagamentos e prevenir fraudes.</li>
      <li>Melhorar desempenho, segurança e confiabilidade.</li>
      <li>
        Usar dados agregados e desidentificados para aprimorar o Benjamin.
      </li>
    </ul>
    <br />
    <div>
      <strong>4. Compartilhamento</strong>
    </div>
    <br />
    <div>
      Compartilhamos dados com provedores essenciais (ex.: hospedagem, e-mail,
      pagamentos) e com provedores de IA quando necessário para processar
      solicitações. Esses parceiros são contratualmente obrigados a proteger os
      dados e não podem utilizá-los para finalidades próprias.
    </div>
    <br />
    <div>
      <strong>5. Transferência internacional</strong>
    </div>
    <br />
    <div>
      Alguns provedores podem operar fora do Brasil. Nesse caso, aplicamos
      mecanismos legais adequados para transferência internacional, conforme a
      LGPD.
    </div>
    <br />
    <div>
      <strong>6. Segurança</strong>
    </div>
    <br />
    <div>
      Adotamos medidas técnicas e organizacionais para proteger os dados, como
      criptografia, controle de acesso e monitoramento.
    </div>
    <br />
    <div>
      <strong>7. Retenção</strong>
    </div>
    <br />
    <div>
      Mantemos dados apenas pelo tempo necessário para cumprir as finalidades
      ou obrigações legais. Conteúdo do Cliente pode ser excluído mediante
      solicitação ou ao término do contrato.
    </div>
    <br />
    <div>
      <strong>8. Direitos do titular</strong>
    </div>
    <br />
    <div>
      Você pode solicitar acesso, correção, portabilidade ou exclusão. Para
      dados fornecidos por sua empresa, o pedido deve ser direcionado ao seu
      empregador/Cliente Controlador.
    </div>
    <br />
    <div>
      Contato de privacidade: <a href="mailto:privacy@leanit101.com">privacy@leanit101.com</a>.
    </div>
    <br />
    <div>
      <strong>9. Cookies</strong>
    </div>
    <br />
    <div>
      Usamos cookies essenciais e armazenamento local para autenticação e
      preferências. Não vendemos dados para marketing de terceiros.
    </div>
    <br />
    <div>
      <strong>10. Alterações</strong>
    </div>
    <br />
    <div>
      Podemos atualizar esta Política. Avisaremos sobre mudanças relevantes.
    </div>
    <br />
    <div>Última atualização: 27 de dezembro de 2025</div>
  </div>
)

const privacyPolicyEn = (
  <div className="leading-12">
    <p>
      This Privacy Policy describes how LEANIT101 SERVIÇOS EM INFORMÁTICA, CNPJ
      22.724.260/0001-42 ("Lean it 101", "we") collects, uses, and shares
      personal data when providing Benjamin.
    </p>
    <br />
    <div>
      <strong>Quick summary</strong>
      <ul>
        <li>We collect data to operate Benjamin and process payments.</li>
        <li>We do not sell personal data.</li>
        <li>You can request access, correction, or deletion.</li>
        <li>We may use de-identified data to improve the product.</li>
      </ul>
    </div>
    <br />
    <div>
      <strong>1. Roles under data protection laws</strong>
    </div>
    <br />
    <div>
      For account, billing, and support data, we act as a Controller. For
      Customer Content submitted by Customers (e.g., end-user data), we act as a
      Processor following the Customer’s instructions.
    </div>
    <br />
    <div>
      <strong>2. Data we collect</strong>
    </div>
    <br />
    <ul>
      <li>
        <strong>Account data:</strong> name, email, company, role, phone.
      </li>
      <li>
        <strong>Payment data:</strong> transactions processed by Stripe.
      </li>
      <li>
        <strong>Usage data:</strong> logs, IP, browser, access events.
      </li>
      <li>
        <strong>Customer Content:</strong> texts, files, and instructions sent
        to Benjamin.
      </li>
      <li>
        <strong>Integrations:</strong> data needed to connect CRMs, calendars,
        and channels.
      </li>
    </ul>
    <br />
    <div>
      <strong>3. How we use data</strong>
    </div>
    <br />
    <ul>
      <li>Provide the Services, support, and operational communications.</li>
      <li>Process payments and prevent fraud.</li>
      <li>Improve performance, security, and reliability.</li>
      <li>Use aggregated and de-identified data to improve Benjamin.</li>
    </ul>
    <br />
    <div>
      <strong>4. Sharing</strong>
    </div>
    <br />
    <div>
      We share data with essential providers (e.g., hosting, email, payments)
      and with AI providers when needed to process requests. These partners are
      contractually required to protect data and may not use it for their own
      purposes.
    </div>
    <br />
    <div>
      <strong>5. International transfers</strong>
    </div>
    <br />
    <div>
      Some providers may operate outside Brazil. We use appropriate safeguards
      for international transfers as required by law.
    </div>
    <br />
    <div>
      <strong>6. Security</strong>
    </div>
    <br />
    <div>
      We apply technical and organizational measures to protect data, including
      encryption, access controls, and monitoring.
    </div>
    <br />
    <div>
      <strong>7. Retention</strong>
    </div>
    <br />
    <div>
      We retain data only as long as necessary for the stated purposes or legal
      obligations. Customer Content can be deleted upon request or upon
      contract termination.
    </div>
    <br />
    <div>
      <strong>8. Your rights</strong>
    </div>
    <br />
    <div>
      You may request access, correction, portability, or deletion. For data
      provided by your company, requests should be directed to your employer or
      Customer Controller.
    </div>
    <br />
    <div>
      Privacy contact: <a href="mailto:privacy@leanit101.com">privacy@leanit101.com</a>.
    </div>
    <br />
    <div>
      <strong>9. Cookies</strong>
    </div>
    <br />
    <div>
      We use essential cookies and local storage for authentication and
      preferences. We do not sell data for third-party marketing.
    </div>
    <br />
    <div>
      <strong>10. Updates</strong>
    </div>
    <br />
    <div>
      We may update this Policy and will notify you of material changes.
    </div>
    <br />
    <div>Last updated: December 27, 2025</div>
  </div>
)

const PrivacyPolicy = () => {
  const { i18n } = useTranslation()
  const isPt = i18n.language && i18n.language.toLowerCase().startsWith('pt')
  return (
    <div className="">
      <Policy
        name={isPt ? 'Política de privacidade' : 'Privacy policy'}
        text={isPt ? privacyPolicyPt : privacyPolicyEn}
      />
    </div>
  )
}

export default PrivacyPolicy
